import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "login",
        component: () =>
            import ("../views/Login.vue"),
    },
    {
        path: "/test",
        name: "test",
        component: () =>
            import ("../views/test.vue"),
    },
    {
        path: "/hotTen",
        name: "hotTen",
        component: () =>
            import ("../views/hotspot/hotTen.vue"),
    },
    {
        path: "/loveTime",
        name: "loveTime",
        component: () =>
            import ("../components/loveTime.vue"),
    },
    {
        path: "/home",
        name: "home",
        component: () =>
            import ("../components/home/index.vue"),
    },
    //全疆地图   自主研发
    {
        path: '/mapChart',
        name: 'mapChart',
        component: () =>
            import ('../views/mapChart.vue')
    },
    {
        path: '/demo',
        name: 'demo',
        component: () =>
            import ('../views/demo.vue')
    },
    // 新疆地图  前辈
    {
        path: '/mapTime',
        name: 'mapTime',
        component: () =>
            import ('../views/mapTime.vue')
    },
    //全疆新闻地图  前辈
    {
        path: '/mapTimes',
        name: 'mapTimes',
        component: () =>
            import ('../views/mapTimes.vue')
    },
    //全疆新闻地图  酒泉
    {
        path: '/mapPand',
        name: 'mapPand',
        component: () =>
            import ('../views/mapPand.vue')
    },
    {
        path: "/header",
        name: "header",
        component: () =>
            import ("../components/home/header.vue"),
    },
    //全国交通热点  老版
    {
        path: "/mapNews",
        name: "mapNews",
        component: () =>
            import ("../views/mapNews.vue"),
    },
    //全国交通热点 新版
    {
        path: "/mapNew",
        name: "mapNew",
        component: () =>
            import ("../views/mapNew.vue"),
    },
    //咨询排行榜
    {
        path: "/phbNews",
        name: "phbNews",
        component: () =>
            import ("../views/phbNews.vue"),
    },
    {
        path: "/twoNews",
        name: "twoNews",
        component: () =>
            import ("../views/twoNew/twoNews.vue"),
    },
    {
        path: "/bigTW",
        name: "bigTW",
        component: () =>
            import ("../views/twoNew/bigTW.vue"),
    },
    {
        path: "/leader",
        name: "leader",
        component: () =>
            import ("../views/leader.vue"),
    },
    // 领导人活动  --酒泉
    {
        path: "/quEde",
        name: "quEde",
        component: () =>
            import ("../views/quEde.vue"),
    },
    //首发集团合并
    {
        path: "/timeMon",
        name: "timeMon",
        component: () =>
            import ("../views/timeMon.vue"),
    },
    // 宁波集团合并
    {
        path: "/hotMon",
        name: "hotMon",
        component: () =>
            import ("../views/hotMon.vue"),
    },
    {
        path: "/good",
        name: "good",
        component: () =>
            import ("../views/good.vue"),
    },
    {
        path: "/videoes",
        name: "videoes",
        component: () =>
            import ("../views/timeMoon/videoes.vue"),
    },
    //本地新闻
    {
        path: "/mapTimess",
        name: "mapTimess",
        component: () =>
            import ("../views/timeMoon/mapTimess.vue"),
    },
    //本地新闻
    {
        path: "/newMons",
        name: "newMons",
        component: () =>
            import ("../views/timeMoon/newMons.vue"),
    },
    //热点分析3.0
    {
        path: "/hotspots3.0",
        name: "hotspots3.0",
        component: () =>
            import ("../views/timeMoon/hotspots3.0.vue"),
    },
    //京开咨询 -小屏
    {
        path: "/Informations",
        name: "Informations",
        component: () =>
            import ("../views/timeMoon/Informations.vue"),
    },

    //热点分析总合并
    {
        path: "/hotNewsTime",
        name: "hotNewsTime",
        component: () =>
            import ("../views/hotNewsTime.vue"),
    },
    // 热点新闻
    {
        path: "/hotNews",
        name: "hotNews",
        component: () =>
            import ("../views/hotNews.vue"),
    },

    // 科技热点信息分析
    {
        path: "/hotKens",
        name: "hotKens",
        component: () =>
            import ("../views/hotKens.vue"),
    },
    // 集团新闻
    {
        path: "/groupNews",
        name: "groupNews",
        component: () =>
            import ("../views/groupNews.vue"),
    },
    // 消防资讯
    {
        path: "/groupNewsFireFighting",
        name: "groupNewsFireFighting",
        component: () =>
            import ("../views/groupNewsFireFighting.vue"),
    },
    // 消防
    {
        path: "/InformationsFireFighting",
        name: "InformationsFireFighting",
        component: () =>
            import ("../views/timeMoon/InformationsFireFighting.vue"),
    },
    // 大漠问天 --酒泉
    {
        path: "/splin",
        name: "splin",
        component: () =>
            import ("../views/splin.vue"),
    },
    // 京卡咨询
    {
        path: "/Information",
        name: "Information",
        component: () =>
            import ("../views/Information.vue"),
    },

    // 视频汇聚
    {
        path: "/video",
        name: "video",
        component: () =>
            import ("../views/video.vue"),
    },
    // 消防视频汇聚
    {
        path: "/video",
        name: "video",
        component: () =>
            import ("../views/video.vue"),
    },
    {
        path: "/newMon",
        name: "newMon",
        component: () =>
            import ("../views/newMon/newMon.vue"),
    },
    {
        path: "/traffic",
        name: "traffic",
        component: () =>
            import ("../views/traffic.vue"),
    },
    // 热点新闻--酒泉
    {
        path: "/hotPand",
        name: "hotPand",
        component: () =>
            import ("../views/hotPand.vue"),
    },
    {
        path: "/hotPand3.0",
        name: "hotPand3.0",
        component: () =>
            import ("../views/hotPand/hotPand3.0.vue")
    },
    {
        path: "/hotPand4.0",
        name: "hotPand4.0",
        component: () =>
            import ("../views/hotPand/hotPand4.0.vue"),
    },
    {
        path: "/hotPand5.0",
        name: "hotPand5.0",
        component: () =>
            import ("../views/hotPand/hotPand5.0.vue"),
    },

    {
        path: "/hotspot3.0",
        name: "hotspot3.0",
        component: () =>
            import ("../views/hotspot/hotspot3.0.vue")
    },
    {
        path: "/hotspot4.0",
        name: "hotspot4.0",
        component: () =>
            import ("../views/hotspot/hotspot4.0.vue"),
    },
    {
        path: "/hotspot5.0",
        name: "hotspot5.0",
        component: () =>
            import ("../views/hotspot/hotspot5.0.vue"),
    },
    // 科技热点信息分析3.0
    {
        path: "/hotKen3.0",
        name: "hotKen3.0",
        component: () =>
            import ("../views/hotKens/hotKen3.0.vue")
    },
    {
        path: "/hotKen4.0",
        name: "hotKen4.0",
        component: () =>
            import ("../views/hotKens/hotKen4.0.vue")
    },
    {
        path: "/hotKen5.0",
        name: "hotKen5.0",
        component: () =>
            import ("../views/hotKens/hotKen5.0.vue")
    },

    // 红山网数据分析
    {
        path: "/HongNetworks",
        name: "HongNetworks",
        component: () =>
            import ("../pages/Uram/HongNetwork/HongNetworks.vue"),
    },
    //红山网数据分析app
    {
        path: "/HongNetwork",
        name: "HongNetwork",
        component: () =>
            import ("../pages/Uram/HongNetwork/index.vue"),
    },
    //竞媒对比播报
    {
        path: "/Uramview",
        name: "Uramview",
        component: () =>
            import ("../pages/Uram/Uramview/index.vue"),
    },
    //全市各单位最新发布
    {
        path: "/newsGod",
        name: "newsGod",
        component: () =>
            import ("../pages/Uram/Uramview/newsGod.vue"),
    },

    //热词新闻汇聚
    {
        path: "/latests",
        name: "latests",
        component: () =>
            import ("../pages/Uram/HongNetwork/latests.vue"),
    },
    //外部媒体看本地
    {
        path: "/medium",
        name: "medium",
        component: () =>
            import ("../views/medium.vue"),
    },
    //外部媒体看本地
    {
        path: "/medvm",
        name: "medvm",
        component: () =>
            import ("../views/medvm.vue"),
    },
    // 乌鲁木齐重点事件跟踪(布局)
    {
        path: "/Keyevents",
        name: "Keyevents",
        component: () =>
            import ("../pages/Uram/Keyevents/index.vue"),
    },
    // 乌鲁木齐改革开放40周年（布局）
    {
        path: "/Gaiform",
        name: "Gaiform",
        component: () =>
            import ("../pages/Uram/Gaiform/index.vue"),
    },

    // 乌鲁木齐媒体传播力(fastmock假数据，缺周,月)
    {
        path: "/Mediacommunication",
        name: "Mediacommunication",
        component: () =>
            import ("../pages/Uram/Mediacommunication/index.vue"),
    },
    // 乌鲁木齐领导人活动
    {
        path: "/Uramleader",
        name: "Uramleader",
        component: () =>
            import ("../pages/Uram/Uramleader/index.vue"),
    },
    // 乌鲁木齐重要稿件列表(布局)
    {
        path: "/manuscript",
        name: "manuscript",
        component: () =>
            import ("../pages/Uram/manuscript/index.vue"),
    },

    // 乌鲁木齐素材下载 文稿统计(fastmock数据)
    {
        path: "/sourceMaterial",
        name: "sourceMaterial",
        component: () =>
            import ("../pages/Uram/sourceMaterial/index.vue"),
    },
    // 乌鲁木齐自媒体传播指数(fastmock数据，只接了红山网数据)
    {
        path: "/Wemedia",
        name: "Wemedia",
        component: () =>
            import ("../pages/Uram/Wemedia/index.vue"),
    },
    // 乌鲁木齐发布排名
    {
        path: "/Releaseranking",
        name: "Releaseranking",
        component: () =>
            import ("../pages/Uram/Releaseranking/index.vue"),
    },
    // 抖音排行榜
    {
        path: "/douyin",
        name: "douyin",
        component: () =>
            import ("../pages/Uram/douyin/index.vue"),
    },
    // 视频号排行榜
    {
        path: "/shipinhao",
        name: "shipinhao",
        component: () =>
            import ("../pages/Uram/shipinhao/index.vue"),
    },
    // 快手排行榜
    {
        path: "/kuaishou",
        name: "kuaishou",
        component: () =>
            import ("../pages/Uram/kuaishou/index.vue"),
    },
    // 乌鲁木齐微信微博发布
    {
        path: "/wxwbrelease",
        name: "wxwbrelease",
        component: () =>
            import ("../pages/Uram/wxwbrelease/index.vue"),
    }
];
const router = new VueRouter({
    // base: '', // 基础路径
    mode: "history",
    routes,
});

// router.beforeEach((to, from, next) => {

//     const token = JSON.parse(window.sessionStorage.getItem('token'))
//         //校验非登录页面的登录状态
//     if (to.path !== '/') {
//         if (token) {
//             //已登录，允许通过
//             next()
//         } else {
//             //没有登录，跳转到登录页面
//             next('/')
//         }
//     } else {
//         //登录页面，正常允许通过
//         next()
//     }

// })
export default router;
